import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioCollectiveAddonEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioCollectiveAddonEntity
